import Creneau from '@/generated/classes/Creneau';
export default class CreneauExtend extends Creneau {

  public menuActive: boolean = false;

  constructor() {
    super();
  }
}
